import Fetcher from "../../../Common/Fetch";
import { IAppChangeStatusModel } from "../../../TradeApplication/types";

export function GetDocumentsPromise(lotId: Number) {
    console.log('GetDataByOpenAuction lotId=', lotId);
    return Fetcher("/TradeLotApi/GetDataByOpenAuction?lotId=" + lotId.toString(), {
        method: 'GET', headers: { 'Content-Type': 'application/json' }
    })
        .then(res => res.json());
}

export function GetBetsTablePromise(lotId: Number) {
    console.log('GetDataByOpenAuction lotId=', lotId);
    return Fetcher("/TradeLotApi/GetDataByOpenAuction?lotId=" + lotId.toString(), {
        method: 'GET', headers: { 'Content-Type': 'application/json' }
    })
        .then(res => res.json());
}

export function GetBetsPromise(lotId: Number) {
    console.log("GetBets lotId=", lotId);
    return Fetcher(`/TradeLotApi/GetBets?lotId=${lotId}`, {
        method: "GET"
    })
        .then(res => res.json());
}

export function TradeApplicationChangeStatus(model: IAppChangeStatusModel) {

    return Fetcher("/TradeApplicationApi/TradeApplicationChangeStatus", {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(model)
    })
        .then(res => res.json());
}

export function FinishTrade(lotId: Number) {
    const TradeLotActionsModel = {
        LotId: lotId
    };
    return Fetcher("/TradeLotActionsApi/FinishLot", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(TradeLotActionsModel)
    })
        .then(res => res.json());
}

export function AssignTradeAsFailed(lotId: Number) {
    const TradeLotActionsModel = {
        LotId: lotId
    };
    return Fetcher("/TradeLotActionsApi/AssignTradeAsFailed", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(TradeLotActionsModel)
    })
        .then(res => res.json());
}

export function GetLotDocuments(lotId) {
    return Fetcher(`/TradeLot/GetLotsDocument?lotId=${lotId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(result => result.json())
}